module.exports = __webpack_public_path__ + "img/chest-top.d198e350.svg";